export default {
      id: "pin-map-usage",
      viewBox: "0 0 21 29",
      url: __webpack_public_path__ + "img/icons.df848786.svg#pin-map",
      toString: function () {
        return this.url;
      }
    }